<template>
  <div class="join">
    <div class="input">
      <label for="player-name">Your name</label>
      <input type="text" id="player-name" v-model="playerName">
    </div>

    <div class="input">
      <label for="game-id">Game id</label>
      <input type="text" id="game-id" v-model="gameID">
    </div>

    <button class="join" @click="joinButtonClicked">Join Game</button>
    <button class="new" @click="newButtonClicked">New Game</button>
  </div>
</template>

<script>
export default {
  name: 'join-form',
  data () { return {
    gameID: '',
    playerName: ''
  } },
  methods: {
    joinButtonClicked () {
      if (!this.playerName) { alert('Please enter a player name'); return; }
      if (!this.gameID) { alert('You must enter a game id to join. Otherwise, start a new game.'); return; }
      this.$store.dispatch('joinGame', { game: this.gameID, playerName: this.playerName });
    },
    newButtonClicked () {
      if (this.playerName === '') { alert('Must enter a player name'); return; }
      this.$store.dispatch('newGame', this.playerName);
    }
  },
  created () {
    if (this.$cookies.isKey('cgg')) { this.gameID = this.$cookies.get('cgg'); }
    if (this.$cookies.isKey('cgp')) {
      let playerInfo = this.$cookies.get('cgp').split('|');
      this.playerName = playerInfo[1];
    }
  }
}
</script>

<style scoped>
.input {
  text-align: left;
  margin: 10px;
  overflow: hidden;
}

.input label {
  text-transform: uppercase;
  font-weight: bold;
  color: #999;
  font-size: 20px;
}

.input input {
  display: block;
  box-sizing: border-box;
  border: 0px;
  border-bottom: 1px dashed #999;
  font-size: 32px;
  font-weight: bold;
}

#game-id { text-transform: uppercase; }

button {
  text-transform: uppercase;
  border: 1px solid #999;
  font-size: 20px;
  padding: 10px 20px;
  margin: 20px 10px;
}

</style>
